<template>
    <div class="col-lg-4 col-md-4 col-sm-12">
        <ul class="pagination" style="margin-top: 0px">
            <li :class="{ 'disabled': disablePreviousButton }">
                <a href="#" aria-label="Previous" @click.prevent="changePage(current_page - 1)">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li v-for="page in pages" :class="{'active': page === current_page}">
                <a href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li :class="{ 'disabled': disableNextButton }">
                <a href="#" aria-label="Next" @click.prevent="changePage(current_page + 1)">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "pagination",
    props: ['current_page', 'total_pages', 'from', 'to', 'total'],
    data() {
        return {};
    },
    computed: {
        pages() {
            var current = this.current_page;
            var last = this.total_pages;
            var delta = 2;
            var left = current - delta;
            var right = current + delta + 1;
            var range = [];
            var pages = [];
            var l;
            for (var i = 1; i <= last; i++) {
                if (i === 1 || i === last || (i >= left && i < right)) {
                    range.push(i);
                }
            }
            range.forEach(function (i) {
                if (l) {
                    if (i - l === 2) {
                        pages.push(l + 1);
                    } else if (i - l !== 1) {
                        pages.push('...');
                    }
                }
                pages.push(i);
                l = i;
            });
            return pages;
        },
        disablePreviousButton() {
            return this.current_page <= 1;
        },
        disableNextButton() {
            return this.current_page >= this.total_pages;
        },
    },
    methods: {
        changePage(page) {
            if (page !== this.current_page && page > 0 && page <= this.total_pages) {
                this.$emit('go-to-page', page);
            }
        },
    }
}
</script>

<style scoped>

</style>